import clsx from 'clsx';
import { bool, func, number, object, oneOfType, string } from 'prop-types';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import 'assets/styles/components/form/form-radio.scss';

const FormRadio = ({
  name,
  value,
  label = '',
  content = null,
  inputRef = null,
  rules = {},
  className = '',
  required = false,
  disabled = false,
  readOnly = false,
  onChange = null
}) => {
  const { t } = useTranslation();

  const { setValue, register, control } = useFormContext();
  const radioValue = useWatch({ control, name });
  const isChecked = radioValue === value.toString();

  const handleOnChange = (e) => {
    setValue(name, e.target.value, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    onChange && onChange(e);
  };

  return (
    <div
      className={clsx('radio-container', isChecked && 'checked', (disabled || readOnly) && 'disabled')}
      aria-live="polite"
    >
      <label className={clsx('radio-label', className)}>
        <input
          className="input sr-only"
          ref={inputRef}
          name={name}
          type="radio"
          value={value}
          required={required}
          disabled={disabled}
          readOnly={readOnly}
          data-test-id={`${name}-${value}`}
          {...(register && register(name, { ...rules, onChange: (e) => handleOnChange(e) }))}
        />
        <div className="box" />

        {!content && <span>{t(label)}</span>}

        {content && content()}
      </label>
    </div>
  );
};

FormRadio.propTypes = {
  name: string.isRequired,
  value: oneOfType([string, number]).isRequired,
  label: string,
  content: func, // Function returning JSX to add custom label content
  inputRef: oneOfType([func, object]),
  rules: object,
  className: string,
  required: bool,
  disabled: bool,
  readOnly: bool,
  onChange: func
};

export default FormRadio;
